import {PayloadAction, createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {GameInfo} from "app/types/game";
import apiCasino from "app/api/casino";

export interface DataItem {
    price: number;
    stat24: {
        growth: number;
        high: number;
        low: number;
        volume: number;
    };
    symbol: string;
    ts: number;
}

export interface CryptoFuturesData {
    btcData?: DataItem;
    ethData?: DataItem;
    solData?: DataItem;
    ltcData?: DataItem;
    bnbData?: DataItem;
    totalVolume: number;
}

interface HomeProps {
    liveCasinoData: GameInfo[];
    miniGameData: GameInfo[];
    slotsData: GameInfo[];
    originalData: GameInfo[];
    cryptoFuturesData: CryptoFuturesData;
    favoriteGamesData: GameInfo[];
    hotGamesData: GameInfo[];
    editorChoiceData: GameInfo[];
    casinoData: GameInfo[];
}

const initialState: HomeProps = {
    liveCasinoData: [],
    miniGameData: [],
    slotsData: [],
    originalData: [],
    cryptoFuturesData: {
        totalVolume: 0,
    },
    favoriteGamesData: [],
    hotGamesData: [],
    editorChoiceData: [],
    casinoData: [],
};

// ==============================|| SLICE - SNACKBAR ||============================== //

export const refreshFavoriteGamesData = createAsyncThunk("refreshFavoriteGamesData", async () => {
    const {status, data} = await apiCasino.getGameCollectList(1, 40);
    if (status === 200 && data.code === 0) {
        return data?.data?.gameList || [];
    }
});

const home = createSlice({
    name: "home",
    initialState,
    reducers: {
        setLiveCasinoData: (state, action: PayloadAction<GameInfo[]>) => {
            state.liveCasinoData = action.payload;
        },
        setMiniGameData: (state, action: PayloadAction<GameInfo[]>) => {
            state.miniGameData = action.payload;
        },
        setSlotsData: (state, action: PayloadAction<GameInfo[]>) => {
            state.slotsData = action.payload;
        },
        setOriginalData: (state, action: PayloadAction<GameInfo[]>) => {
            state.originalData = action.payload;
        },
        setCryptoFuturesData: (state, action: PayloadAction<any>) => {
            const data = action.payload;

            const getPriceData = (symbol: string) => {
                const prices = data.prices;
                const priceData = prices?.find((v: any) => v.symbol === symbol);
                return (
                    priceData || {
                        price: 0,
                        stat24: {
                            growth: 0,
                            high: 0,
                            low: 0,
                            volume: 0,
                        },
                        symbol: "",
                        ts: 0,
                    }
                );
            };

            const btcData = getPriceData("btc-usdt");
            const ethData = getPriceData("eth-usdt");
            const solData = getPriceData("sol-usdt");
            const ltcData = getPriceData("ltc-usdt");
            const bnbData = getPriceData("bnb-usdt");

            const res = {
                totalVolume: data.totalVolume,
                btcData: btcData,
                ethData: ethData,
                solData: solData,
                ltcData: ltcData,
                bnbData: bnbData,
            };
            const btcDataPrice = Number(btcData?.price || 0);
            const ethDataPrice = Number(ethData?.price || 0);
            const solDataPrice = Number(solData?.price || 0);
            const ltcDataPrice = Number(ltcData?.price || 0);
            const bnbDataPrice = Number(bnbData?.price || 0);

            if (!btcDataPrice || !ethDataPrice || !solDataPrice || !ltcDataPrice || !bnbDataPrice) {
                return;
            }

            state.cryptoFuturesData = res;
        },
        setHotGamesData: (state, action: PayloadAction<GameInfo[]>) => {
            state.hotGamesData = action.payload;
        },
        setEditorChoiceData: (state, action: PayloadAction<GameInfo[]>) => {
            state.editorChoiceData = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(refreshFavoriteGamesData.fulfilled, (state, action: PayloadAction<GameInfo[]>) => {
            state.favoriteGamesData = action.payload;
        });
    },
});

export default home.reducer;

export const {setLiveCasinoData, setMiniGameData, setSlotsData, setOriginalData, setCryptoFuturesData, setHotGamesData, setEditorChoiceData} = home.actions;
